export default [
  '/details',
  '/initial-details',
  '/offers',
  '/complete-details',
  '/payment',
  '/thank-you',
  '/',
];